module.exports = __webpack_public_path__ + "img/exchange_disabled.c96b9a43.png";